"use client"

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { LogOutIcon, User } from "lucide-react";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { Role } from "@prisma/client";
import UserAvatar from "./user-avatar";
import { useSession } from "../auth/session-provider";
import { logout } from "@/server/actions/auth-actions";

interface UserButtonProps {
    className?: string;
}

export default function UserButton({ className }: UserButtonProps) {
    const { user } = useSession()

    if (!user) return null

    return <DropdownMenu>
        <DropdownMenuTrigger asChild>
            <button className={cn("flex-none rounded-full", className)}>
                <UserAvatar avatarUrl={user.avatarUrl} size={40} />
            </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
            {
                user.role !== Role.Guest && <>
                    <DropdownMenuItem asChild className="cursor-pointer">
                        <Link href={"/admin"}>
                            <User className="mr-2 size-4" />
                            Admin
                        </Link>
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                </>
            }
            <DropdownMenuItem asChild className="cursor-pointer">
                <Link href={"/user-dashboard"}>
                    <User className="mr-2 size-4" />
                    Profile
                </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => {
                void logout()
            }}
                className="cursor-pointer"
            >
                <LogOutIcon className="mr-2 size-4" />
                Logout
            </DropdownMenuItem>
        </DropdownMenuContent>
    </DropdownMenu >
}